export default __webpack_public_path__ + "static/media/metal.08f9721f.svg";